/**
 * Star Groups API - 收藏分组管理.
 *
 * 后端端点 (apps/backend/app/api/v1/star_groups.py):
 *   GET    /star-groups                 -> StarGroup[]
 *   POST   /star-groups  { name, sort_order } -> StarGroup
 *   PUT    /star-groups/{id} { name?, sort_order? } -> StarGroup
 *   DELETE /star-groups/{id}             -> 204
 */
import { http } from './client'
import type { StarGroup, UUID } from '@/types/api'

export interface CreateStarGroupRequest {
  name: string
  sort_order?: number
}

export async function listStarGroups(): Promise<StarGroup[]> {
  const res = await http.get<StarGroup[]>('/star-groups')
  return res.data
}

export async function createStarGroup(body: CreateStarGroupRequest): Promise<StarGroup> {
  const res = await http.post<StarGroup>('/star-groups', body)
  return res.data
}

export async function updateStarGroup(
  id: UUID,
  body: { name?: string; sort_order?: number }
): Promise<StarGroup> {
  const res = await http.put<StarGroup>(`/star-groups/${id}`, body)
  return res.data
}

export async function deleteStarGroup(id: UUID): Promise<void> {
  await http.delete(`/star-groups/${id}`)
}
